import { FilterModel } from './filter.model';
import { UUID } from 'angular2-uuid';

export class TableCellModel {
  uuid: string;
  value: string;
  attributename: string;
  sortorder: number;
  filtermodel: FilterModel;
  constructor() {
    this.uuid = UUID.UUID();
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/tablecell.model.ts